"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var SearchAndFilter_1 = __importDefault(require("atomicComponents/organisms/SearchAndFilter"));
var filter_1 = require("utils/filter");
var ordered_1 = require("utils/selectors/ordered");
var ServicesSearchAndFilter = function (_a) {
    var serviceStats = _a.serviceStats, selectedFilters = _a.selectedFilters, setSelectedFilters = _a.setSelectedFilters, searchText = _a.searchText, setSearchText = _a.setSearchText;
    var allUsers = (0, react_redux_1.useSelector)(ordered_1.selectUsers);
    var makeOwnerOptions = (allUsers === null || allUsers === void 0 ? void 0 : allUsers.map(function (_a) {
        var id = _a.id, displayName = _a.displayName, firstName = _a.firstName;
        return ({
            value: id,
            label: displayName || firstName || '',
            category: 'Owners',
        });
    })) || [];
    var companyTeams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    var companyTeamOptions = companyTeams === null || companyTeams === void 0 ? void 0 : companyTeams.map(filter_1.makeTeamOption);
    var opts = __spreadArray(__spreadArray(__spreadArray([], __read(serviceStats.map(filter_1.makeServiceOption)), false), __read(makeOwnerOptions), false), __read(companyTeamOptions !== null && companyTeamOptions !== void 0 ? companyTeamOptions : []), false);
    return ((0, jsx_runtime_1.jsx)(SearchAndFilter_1.default, { searchProperties: { searchText: searchText, setSearchText: setSearchText }, filterProperties: { options: opts, results: selectedFilters, setResults: setSelectedFilters } }));
};
exports.default = ServicesSearchAndFilter;
